import React from 'react'

import { AiFillHome,AiFillMail,AiFillClockCircle } from "react-icons/ai"
import { FiPhoneCall } from "react-icons/fi"
import "./Contact.css"
function Contact() {
    return (
        <>
   
        <div id="contact-page">
            <p className="contact-title">Get in touch</p>
            <div className="contact-flex">
            <div className="contact-info">
            <div className="item">
            <AiFillHome className="contact-icon"/>
                Gujarat,India
            </div>
            <div className="item">
                <FiPhoneCall className="contact-icon"/>
                +91 88661 40344
            </div>
            <div className="item">
                <AiFillMail className="contact-icon"/>
                chotaliyaankit@gmail.com
            </div>
            <div className="item">
               <AiFillClockCircle className="contact-icon"/>
                Mon-Fri 11:00 AM to 5:00 PM
            </div>
            </div>
            <div>
                <form action="" className="contact-form">
                <input type="text" className="textb" placeholder="Your Name"/>
                <input type="email" className="textb" placeholder="Your Email"/>
                <textarea  placeholder="Your Message"/>
                <button type="submit" className="contact-btn">Send</button>
                </form>
                </div>
                </div>
        </div>
    </>
        )
}

export default Contact
